<template>
    <div class="page">
        <div class="weui-msg">
            <div class="weui-msg__icon-area">
                <i class="weui-icon-success weui-icon_msg"></i>
            </div>
            <div class="weui-msg__text-area">
                <h2 class="weui-msg__title">反馈成功</h2>
                <p class="weui-msg__desc">
                    您意见反馈我们已经收到，感谢您对校圆通的支持，我们将尽快确认和处理您的相关反馈，如有需要，我们将会电话与您联系，请知悉。
                </p>
            </div>
            <div class="weui-msg__opr-area">
                <p class="weui-btn-area">
                    <a href="javascript:;" class="weui-btn weui-btn_default" @click="back">返回个人中心</a>
                </p>
            </div>
            <div class="weui-msg__extra-area">
                <div class="weui-footer">
                    <p class="weui-footer__links">
                        <a href="javascript:void(0);" class="weui-footer__link">校圆通</a>
                    </p>
                    <p class="weui-footer__text">Copyright &copy; 2017-{{year}} aixyt.com</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      suggestionId: "",
      encodeToken: "",
      year: moment().format("YYYY")
    };
  },
  created() {
    this.suggestionId = this.$route.params.id;
    this.encodeToken = this.$route.params.token;
  },
  methods: {
    detail() {
      this.$router.push(
        "/suggestionDetail/" + this.suggestionId + "/" + this.encodeToken
      );
    },
    back() {
      this.$router.push("/my/" + this.encodeToken);
    }
  }
};
</script>

<style scoped>
.weui-footer {
  position: fixed;
  bottom: 10px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
</style>





// WEBPACK FOOTER //
// src/components/operations/SuggestionSuccess.vue